import { ColorAliases, Colors } from './variables'

export const Sizes = {
	xxsm: '0.25rem', // 4px
	xsm: '0.33rem', // 6px
	sm: '0.5rem',  // 8px
	// smd: '0.75rem', // 12px
	md: '1rem',    // 16px
	// xmd: '1.25rem',  // 20px
	lg: '1.5rem',  // 24px
	xlg: '2rem',  // 32px
	xxlg: '2.5rem',  // 40px
	xxxlg: '3rem',  // 40px
}

export const AppColors = {
	...ColorAliases,
	Bg1: Colors.WHITE, // ColorAliases.PT_APP_BACKGROUND_COLOR,
	Bg2: Colors.LIGHT_GRAY5,
	Bg3: Colors.LIGHT_GRAY4,
	interactiveBg: `rgba(0,0,0,0)`,
	interactiveBgHover: `rgba(0,0,0,0.03)`,
	interactiveBgActive: `rgba(0,0,0,0.08)`,
	interactiveBgSelected: `rgba(0,0,0,0.06)`,
	shadowGradient: `rgba(0,0,0,0.04), rgba(0,0,0,0)`,
}
